import styled from "styled-components";
import {
  alignContent,
  alignItems,
  bottom,
  display,
  flex,
  flexDirection,
  flexWrap,
  height,
  justifyContent,
  justifyItems,
  maxHeight,
  maxWidth,
  minHeight,
  minWidth,
  order,
  position,
  right,
  space,
  textAlign,
  top,
  width,
  zIndex,
} from "styled-system";

// Universal spacing only Container
export const Container = styled.div`
  ${space}
`;

export const Flex = styled.div.attrs((p) => ({
  ...(p.direction && { flexDirection: p.direction }),
}))`
  ${display}
  ${position}
  ${space}
  ${alignItems}
  ${justifyContent}
  ${flexWrap}
  ${flexDirection}
  ${alignContent}
  ${justifyItems}
  ${width}
  ${height}
  ${bottom}
  ${right}
  ${minHeight}

  // As a flex child
  ${flex}
`;
Flex.defaultProps = {
  display: "flex",
};

export const InlineFlex = styled(Flex)`
  display: inline-flex;
`;

export const Box = styled.div`
  ${space}
  ${display}
  ${alignItems}
  ${justifyContent}
  ${position}
  ${right}
  ${textAlign}
  ${zIndex}

  flex-grow: ${(p) => p.flexGrow || 0};

  ${width}
  ${height}
  ${flex}
  ${order}
  ${flexDirection}
  ${top}
  ${bottom}

  ${minWidth}
  ${maxWidth}
  ${minHeight}
  ${maxHeight}
`;
